<template>
	<div class="reportList">
	    <div class="o-main-content-area">
	        <div class="o-page-top-heading c-responsive-fixwidth">
	            <div class="row">
	                <div class="col-md-9">
	                    <h1 class="h1">Reports:</h1>
	                </div>
	                 <div class="col-md-3">
	                    <div class="input-group stylish-input-group" style="display:none">
	                        <input v-on:input="onSearchReports" v-model="searchInputdata" type="text" class="form-control" placeholder="Search">
	                        <span class="input-group-addon">
	                        <button type="submit">
	                            <span class=""><i class="fa fa-search" aria-hidden="true"></i></span>
	                        </button>
	                        </span>
	                    </div>
	                </div> 
	            </div>
	            <div class="o-individual-calls clearfix o-overflow-visible">
	                <div class="col-md-5 col-sm-12 o-no-padding c-common-space c-common-box-shadow c-radius3">
	                    <div class="form-inline c-user-tab-content u-padding-20">
	                        <div class="form-group">
	                            <label for="exampleInputEmail3" class="common-label-text">Select Report Type:</label>
	                             <div class="o-cutsomSelect o-display-inline">
                                    <select v-model="selectFilter" class="form-control fix-width-input">
                                        <option value="jobByMonth">Monthly job report</option>
                                        <option value="jobByYear">Yearly job report</option>
                                        <option v-if="checkCalculateHoursPower()" value="calculateHours">Calculate Hours Total</option>
                                    </select>
                                </div>
	                        </div>
	                        <button @click="onFilter()" class="c-common-btn c-common-btn--green">Go</button>
	                    </div>
	                </div>
	            </div>
	            <div class="c-common-space o-individual-calls o-no-margin">
	                <div class="col-sm-3 skillset o-no-padding">
	                    <span class="common-label-text">Report for:</span>
	                    
	                    <el-date-picker
	                    	v-if="selectFilter=='jobByMonth'"
                        	v-model="select_date"
                        	class="o-inline-datepicker-icon"
                        	type="month"
                        	format="MMMM yyyy"
                        	placeholder="">
                      	</el-date-picker>
                      	<el-date-picker
                      		v-if="selectFilter=='jobByYear'"
					    	v-model="select_date"
					    	class="o-inline-datepicker-icon"
					    	type="year"
					    	format="yyyy"
					    	placeholder="">
					  	</el-date-picker>
	                </div>
	            </div>
	        </div>
            <div 
                v-loading="loading" 
                class="o-ndividualArea c-responsive-fixwidth" 
                infinite-scroll-disabled="busy" 
                infinite-scroll-distance="10"
                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                ref="scrollContainer"
                style="min-height: 1px;"
            >
                <div class="c-common-space o-individual-calls u-margin-10">
                    <div class="col-md-12 o-no-padding">
                        <h5 class="c-common-heading">Total Jobs / Calls : {{totalReports+' / '+totalCalls}}</h5>
                    </div>
                </div>

                <div v-for="(report,index) in reportList" :key="index" class="o-custom-table-container c-common-box-shadow c-radius3 report-list-table-align o-overflow-visible">
                    <div class="o-calls-table c-common-gradient o-overflow-visible">
                        <div class="calls-table-row phonesheet-table-row">

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Job ID:</span>
                                            <div>{{report.job_number}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Employer:</span>
                                            <div>{{(report.employer)?report.employer.name:''}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="calls-table-cell-inner-table">
                                        <div class="o-accordion-subtext o-rowtable-text">
                                            <span>Steward:</span>

                                            <div>{{(report.employee && report.employee.employable)?report.employee.employable.first_name+" "+report.employee.employable.last_name:''}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Event:</span>
                                        <div>{{report.title}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span>Payroll company:</span>
                                        <div>{{(report.payroll)?report.payroll.name:''}}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                        <span># of Calls:</span>
                                        <div class="text-center">{{(report.calls_count && report.calls_count.length>0)?report.calls_count[0].aggregate:'0'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text o-table-center">
                                        <span>Job Report:</span>
                                        <div class="o-accordion-element o-table-checklist text-center o-no-pad-right">
                                            <i v-if="report.hw.length>0" class="fa fa-check-circle" aria-hidden="true"></i>
                                            <i v-if="report.hw.length==0" class="fa fa-times-circle" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="table-td-border-right">
                                    <div class="o-accordion-subtext o-rowtable-text o-table-center">
                                        <span>HW:</span>
                                        <div class="o-accordion-element o-table-checklist text-center o-no-pad-right">
                                            <i v-if="report.report.length>0" class="fa fa-check-circle" aria-hidden="true"></i>
                                            <i v-if="report.report.length==0" class="fa fa-times-circle" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="calls-table-cell">
                                <div class="">
                                    <div class="o-accordion-subtext o-rowtable-text">
                                    <span>View:</span>
                                        <a href="javascript: void(0)" @click="viewReportDetails(report)" class="view-icon"><i class="fa fa-eye" aria-hidden="true"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="reportList.length==0 && afterAPI==true" class="">
                    <div class="c-common-space c-responsive-fixwidth c-common-gradient c-common-box-shadow c-radius3">
                        <div class="col-md-12 no-job-dispaly">
                            <i class="fa fa-frown-o" aria-hidden="true"></i>
                            <br />
                            No Data Stored
                        </div>
                    </div>
                </div>        
            </div>
	    </div>
    </div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import { mapGetters } from 'vuex';
    import { global } from '../../global.js';
    import service from '../../services.js';

    export default {
        data() {
            return {
                reportList: [],
                storeMore: [],
                selectFilter: 'jobByYear',
                next_page: '',
                select_date: new Date(),
                totalReports: 0,
                totalCalls: 0,
                loading: false,
                afterAPI: false,
                searchInputdata: '',
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                userID: 'userID',
                userRoleSlug: 'userRoleSlug'
            })
        },
        methods: {
            checkCalculateHoursPower(){
                if(this.userRoleSlug != 'employee'){
                    return true;
                }
                return false;
            },
            viewReportDetails(job) {
                this.$store.dispatch('setJob', job);
                this.$router.push({
                    path: `/report/`+btoa(job.id)
                });
            },
            onFilter() {
                switch (this.selectFilter) {
                    case 'jobByYear':
                        this.getAllReportsByYear();
                        break;
                    case 'jobByMonth':
                        this.getAllReportsByMonth();
                        break;
                    case 'calculateHours':
                        let year = moment(this.select_date).year();
                        service.get('reports/generateCsvReport', {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'clientId': this.userClientID,
                        })
                        .then((res) => {
                            this.JSONToCSVConvertor(res.data.result, "Hours Total", true);
                        }).catch((err) => {
                            console.log(err);
                        })
                        break;
                    default:
                        //console.log("error in select filter.");
                }
            },
            JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
                var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
                var CSV = '';
                CSV += ReportTitle + '\r\n\n';
                if (ShowLabel) {
                    var row = "";
                    for (var index in arrData[0]) {
                        row += index + ',';
                    }
                    row = row.slice(0, -1);
                    CSV += row + '\r\n';
                }
                for (var i = 0; i < arrData.length; i++) {
                    var row = "";
                    for (var index in arrData[i]) {
                        row += '"' + arrData[i][index] + '",';
                    }
                    row.slice(0, row.length - 1);
                    CSV += row + '\r\n';
                }

                if (CSV == '') {
                    alert("Invalid data");
                    return;
                }
                var fileName = "Calculate_";
                fileName += ReportTitle.replace(/ /g, "_");
                var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
                var link = document.createElement("a");
                link.href = uri;
                link.style = "visibility:hidden";
                link.download = fileName + ".csv";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            },
            getAllReportsByYear() {
                this.loading = true;
                this.afterAPI = false;
                let year = moment(this.select_date).year();
                this.storeMore = [];
                this.reportList=[];
                service.get('job/jobByYear', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'year': year,
                })
                .then((res) => {
                    this.loading = false;
                    this.reportList = res.data.result.data;
                    this.totalReports = res.data.result.total;
                    this.totalCalls =res.data.status_message.Total_calls_per_year;
                    this.next_page = res.data.result.next_page_url;
                    this.afterAPI = true;
                    if (this.next_page != null) {
                        service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'year': year,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            })
                    }

                }).catch((err) => {
                    this.loading = false;
                    this.afterAPI = true;
                    console.log(err);
                })
            },
            getAllReportsByMonth() {
                this.loading = true;
                this.afterAPI = false;
                let month = moment(this.select_date).month() + 1;
                let year = moment(this.select_date).year();
                this.storeMore = [];
                this.reportList=[];
                service.get('job/reportJobByMonth', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'month': month,
                        'year': year,
                    })
                    .then((res) => {
                        this.loading = false;
                        this.reportList = res.data.result.data;
                        this.totalReports = res.data.result.total;
                        this.totalCalls =res.data.status_message.Total_calls_per_month;
                        this.next_page = res.data.result.next_page_url;
                        this.afterAPI = true;
                        if (this.next_page != null) {
                            service.getUrl(this.next_page, {
                                'Authorization': this.userToken,
                                'cs3-context-role': this.userRole,
                                'cs3-context-clientId': this.userClientID,
                                'month': month,
                                'year': year,
                            })
                            .then((res) => {
                                this.storeMore = res.data.result.data;
                                this.next_page = res.data.result.next_page_url;

                            }).catch((err) => {
                                console.log(err);
                            })
                        }

                    }).catch((err) => {
                        this.loading = false;
                        this.afterAPI = true;
                        console.log(err);
                    })
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                let month = moment(this.select_date).month() + 1;
                let year = moment(this.select_date).year();
                if (this.storeMore.length != 0) {
                    var arr = this.reportList;
                    for (var key in this.storeMore){
                        arr.push(this.storeMore[key]);
                    }
                    this.storeMore=[];
                    if (this.next_page != null) {
                        await service.getUrl(this.next_page, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'month': month,
                            'year': year,
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.next_page = res.data.result.next_page_url;
                        }).catch((err) => {
                            console.log(err);
                        })
                    } else {
                        this.storeMore = [];
                    }
                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },
            onSearchReports() {
                if (this.searchInputdata.length > 0) {
                    let month = new Date(this.select_date).getMonth() + 1;
                    let year = new Date(this.select_date).getFullYear();
                    service.get('job/jobSearch', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID,
                        'jobSearch': this.searchInputdata,
                        'month': month,
                        'year': year,
                    })
                    .then((res) => {
                        this.reportList = res.data.result;
                        this.totalReports = this.reportList.length;
                        this.next_page = '';
                        this.storeMore = [];
                    }).catch((err) => {
                        console.log(err);
                    })
                } else {
                    this.getAllReportsByYear();
                }
            }
        },

        created() {
            this.getAllReportsByYear();
        }
    }

</script>
